import type { SanityPlanCompareCategory } from "./useComparePlanTableSectionState";
import { ComparePlanTableCategory } from "./comparePlanTableCategory.component";

export const ComparePlanTableCategories = ({
  categories,
  gridTemplateColumns,
  columnCount,
}: ComparePlanTableCategoriesProps) => {
  if (!categories.length) return null;

  return (
    <div
      data-testid="compare-plan-table-categories"
      className="lg:scrollbar-hide flex w-full flex-col lg:grid lg:overflow-x-auto"
      style={{ gridTemplateColumns }}>
      {categories.map((category) => (
        <ComparePlanTableCategory
          key={category.id}
          category={category}
          gridTemplateColumns={gridTemplateColumns}
          columnCount={columnCount}
        />
      ))}
    </div>
  );
};

type ComparePlanTableCategoriesProps = {
  categories: SanityPlanCompareCategory[];
  gridTemplateColumns: string;
  columnCount: number;
};
